import { Component, OnInit } from '@angular/core';
import { Department } from '../department';
import { DepartmentService } from '../department.service';

import { ActivatedRoute, Params } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Location } from '@angular/common';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-department-list',
  templateUrl: './department-list.component.html',
  styleUrls: ['./department-list.component.css']
})
export class DepartmentListComponent implements OnInit {

  closeResult: string; 
  page=1;
    
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  department = new Department();  //Po is defined from abobe import po
  departments: Department[];
  submitted = false;
  message: string;	


  departmentFilter: any = { deptname: '' };
  totalrecord:number;

  constructor(private departmentService: DepartmentService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location,
    private modalService: NgbModal
    ) { }

    open(content,deptid) {
    //  this.GetDepartmentDetails(deptid);
      this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }

    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return  `with: ${reason}`;
      }
    }

  ngOnInit(): void {
    this.getDepartments();
    
  }

  // GetDepartmentDetails(deptid) {
  //  // const id = +this.route.snapshot.paramMap.get('poid');
  //   this.departmentService.GetDepartmentDetails(deptid)
  //     .subscribe(department => this.department = department);
  // }

  getDepartments() {
    this.spinnerService.show();    
    return this.departmentService.getDepartments()
               .subscribe(
                departments => {              
                  this.departments = departments
                  this.spinnerService.hide();
                  this.totalrecord = this.departments.length;
                  
                 }
                );
 }



 update(): void {
  this.submitted = true;
  this.departmentService.updateDepartment(this.department)
      .subscribe(() => 
	  { this.message = "Department Updated Successfully!" });
}

delete(deptid): void {
  //this.submitted = true;
  this.departmentService.deleteDepartment(deptid)
      .subscribe(()=>
		{	  this.message = "Department Deleted Successfully!";
			this.getDepartments();   
		});
   
}


  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}

}
